import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { GenericModalService } from '../../../services/generic-modal.service';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {NodeConfigurationService} from '../../../services/configuration/node-configuration.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidator} from '../../../services/custom-validator';

@Component({
  selector: 'app-service-configuration-api',
  templateUrl: './service-configuration-api.component.html',
  styleUrls: ['./service-configuration-api.component.css']
})
export class ServiceConfigurationApiComponent implements OnInit {

  @Input() modalTitle: string;
  apiComponentForm: FormGroup;
  objInitialState;
  config;
  error;
  submitted;

  pleaseWait = false;
  get formData() { return this.apiComponentForm.controls; }

  constructor(
    private nodeConfigService: NodeConfigurationService,
    private modalService: GenericModalService,
    private formBuilder: FormBuilder, public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.submitted= false;

    if (this.objInitialState){
      this.config = this.objInitialState;
    }
    this.createForm();
    this.loadConfigs();

  }

  createForm() {
    this.apiComponentForm = this.formBuilder.group({
      communicationKey:  [null],
      updateDriverServiceUri: [null],
      attachmentRepositoryType: [ null],
      attachmentRepositoryPath: { value: null },
      impersonateAuthentication: [false],
      inMemoryServiceIp: [null,[ CustomValidator.trimRequired, Validators.maxLength(100) ]],
      inMemoryServicePort: [0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      userSessionIdleTimeout: [0,[ Validators.required, Validators.min(1), Validators.max(2147482), CustomValidator.numeric ]],
      batcherNetworkAddress: [null],
      pendingInstancesQueue:[null, CustomValidator.trimRequired],
      syncInstancesQueue:[null, CustomValidator.trimRequired],
      syncResultInstancesQueue:[null, CustomValidator.trimRequired],
      pendingBatchInstancesQueue:[null, CustomValidator.trimRequired],
      pendingBatchItemQueue:[null, CustomValidator.trimRequired],
      scheduledNextStatesExecutionQueue:[null, CustomValidator.trimRequired],
      suspendedInstancesQueue:[null, CustomValidator.trimRequired],
      interactionTimeoutQueue:[null, CustomValidator.trimRequired],
      interactionInstanceQueue:[null, CustomValidator.trimRequired],
      overrideQueue:[null, CustomValidator.trimRequired]
    });
  }

  loadConfigs() {
    this.error = '';
    this.nodeConfigService.getByNode(this.config.machineId, this.config.hostName, 2)
      .subscribe(result => {
        if (result) {
          this.apiComponentForm.patchValue({
            communicationKey:  result.communicationKey,
            updateDriverServiceUri: result.updateDriverServiceUri,
            attachmentRepositoryType: result.attachmentRepositoryType.toString(),
            attachmentRepositoryPath: result.attachmentRepositoryPath,
            impersonateAuthentication: result.impersonateAuthentication,
            inMemoryServiceIp: result.inMemoryServiceIp,
            inMemoryServicePort: result.inMemoryServicePort,
            userSessionIdleTimeout: result.userSessionIdleTimeout,
            batcherNetworkAddress: result.batcherNetworkAddress,
            pendingInstancesQueue: result.pendingInstancesQueue,
            syncInstancesQueue: result.syncInstancesQueue,
            syncResultInstancesQueue: result.syncResultInstancesQueue,
            pendingBatchInstancesQueue: result.pendingBatchInstancesQueue,
            pendingBatchItemQueue: result.pendingBatchItemQueue,
            scheduledNextStatesExecutionQueue: result.scheduledNextStatesExecutionQueue,
            suspendedInstancesQueue: result.suspendedInstancesQueue,
            interactionTimeoutQueue: result.interactionTimeoutQueue,
            interactionInstanceQueue: result.interactionInstanceQueue,
            overrideQueue: result.overrideQueue
          });
          this.pleaseWait = false;
          // @ts-ignore
          $('#cardQueues').CardWidget('collapse');
          this.onAttachmentRepositoryTypeChange();
        }
      }, error1 => {
        this.error = error1;
        this.pleaseWait = false;
      });
  }

  onClose() {
    this.bsModalRef.hide();
  }

  onSave() {
    this.error = '';
    this.pleaseWait = true;
    const obj = this.apiComponentForm.getRawValue();
    obj.machineId = this.config.machineId;
    obj.hostName = this.config.hostName;
    this.nodeConfigService.updateApi(obj).subscribe(
      () => {
        this.pleaseWait = false;
        this.submitted = true;
        setTimeout(() => {  this.submitted = false; }, 1700);
      }, error1 => {
        this.pleaseWait = false;
        this.error = error1;
      }
    );
  }

  onAttachmentRepositoryTypeChange() {
    if (this.formData.attachmentRepositoryType.value == "1"){
      this.apiComponentForm.get('attachmentRepositoryPath').setValidators(CustomValidator.trimRequired);
    } else {
      this.apiComponentForm.get('attachmentRepositoryPath').clearValidators();
      this.apiComponentForm.patchValue({
        attachmentRepositoryPath: null
      });
      this.apiComponentForm.updateValueAndValidity();
    }
  }

}
